/**
 * The two links Share my calendar hands out (contract §18), under the app's
 * base and on this site's own host. `list` is `encodeSavedList`'s.
 */

const base = () => `${window.location.host}${import.meta.env.BASE_URL}`;

/** The subscription: the Pages Function at `functions/calendar/[ids].ics.ts`. */
export const feedUrl = (list: string) => `webcal://${base()}calendar/${list}.ics`;

/** The read-only Shared calendar: Saved, over the ids in the link rather than the visitor's own. */
export const sharedCalendarUrl = (list: string, city: string) =>
  `${window.location.protocol}//${base()}saved?ids=${list}&city=${city}`;
